import {
  buildSettingControlChildPair,
  buildSettingControlMappingPairs,
  pruneFieldMappingsHiddenBySettingControl,
  pruneFormValuesHiddenChildrenBySettingControl,
  SettingControlChildPair,
  SettingControlMappingPair,
} from './settingControlVisibilityPersistence'

export type SettingControlSyncPairInput = {
  thisSetting: any
  oppositeSetting: any | null | undefined
  settingField: string
}

export const buildSettingControlSyncPairs = (
  inputs: SettingControlSyncPairInput[]
): {mappingPairs: SettingControlMappingPair[]; childPairs: SettingControlChildPair[]} => {
  const mappingPairs: SettingControlMappingPair[] = []
  const childPairs: SettingControlChildPair[] = []

  inputs.forEach(({thisSetting, oppositeSetting, settingField}) => {
    const mappingPair = buildSettingControlMappingPairs(thisSetting, oppositeSetting)
    if (mappingPair) {
      mappingPairs.push(mappingPair)
    }
    const childPair = buildSettingControlChildPair(thisSetting, oppositeSetting, settingField)
    if (childPair) {
      childPairs.push(childPair)
    }
  })

  return {mappingPairs, childPairs}
}

export const collectPlatformSettingSyncPairs = (
  platformSettings: any[] | null | undefined,
  resolveOppositeSetting: (setting: any) => any | null | undefined,
  resolveSettingField: (groupCode?: string) => string
): SettingControlSyncPairInput[] =>
  (platformSettings ?? []).map((thisSetting) => ({
    thisSetting,
    oppositeSetting: resolveOppositeSetting(thisSetting),
    settingField: resolveSettingField(thisSetting?.group_code),
  }))

export const runSettingControlHiddenStateSync = (params: {
  fieldMappings: any[]
  formValues: Record<string, any>
  savedMappings: any[]
  syncPairs: SettingControlSyncPairInput[]
}): {
  fieldMappings: any[]
  formValues: Record<string, any>
  mappingsChanged: boolean
  valuesChanged: boolean
} => {
  const {mappingPairs, childPairs} = buildSettingControlSyncPairs(params.syncPairs)
  const prunedMappings = pruneFieldMappingsHiddenBySettingControl(
    params.fieldMappings,
    mappingPairs,
    params.savedMappings
  )
  const {values: prunedValues, changed: valuesChanged} =
    pruneFormValuesHiddenChildrenBySettingControl(
      params.formValues,
      childPairs,
      params.fieldMappings,
      params.savedMappings
    )

  return {
    fieldMappings: prunedMappings,
    formValues: prunedValues,
    mappingsChanged: prunedMappings !== params.fieldMappings,
    valuesChanged,
  }
}
